// Port of api/fuel/app/classes/filter/search/games/filters/query/rating/disparity/group/community.php
import F from 'offline/filter/constants'
import Util from 'offline/util'
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'rating.disparity.group.community',
	priority: 73,
	require: function(config, filter) {
		return config.ownerType !== F.OWNER_USER && rangeActive(filter.disparity && filter.disparity.group && filter.disparity.group.community, -10, 10)
	},
	run: function(config, filter, data, query) {
		query.select('AVG(r.rating_value) - g.game_rating_avg', 'gc_disparity')
		if (filter.disparity.group.community.from !== -10) {
			query.having('!gc_disparity', '>=', Util.adjustedRating(filter.disparity.group.community.from))
		}
		if (filter.disparity.group.community.to !== 10) {
			query.having('!gc_disparity', '<=', Util.adjustedRating(filter.disparity.group.community.to, true))
		}
	}
}
